import FeatureGates from '@atlaskit/feature-gate-js-client';

import Language from './language';
import LanguageCache from './language-cache';
import { languages } from './languages';
import { languages as oldLanguages } from './languages-old';

const languageCache = new LanguageCache();
const oldLanguageCache = new LanguageCache();

Object.entries(languages).forEach(([name, options]) => {
  languageCache.register(new Language(name, options));
});

Object.entries(oldLanguages).forEach(([name, options]) => {
  oldLanguageCache.register(new Language(name, options));
});

// @ts-ignore TODO: fix noImplicitAny error here
const getExtension = filename => {
  const split = filename.split('.');
  return split.length > 1 ? `.${split.pop()}` : null;
};

export default (filename: string): Language | null => {
  if (FeatureGates.checkGate('bbc-new-source-browser-languages')) {
    return (
      languageCache.getByFileName(filename) ||
      languageCache.getByExtension(getExtension(filename)) ||
      null
    );
  }

  return (
    oldLanguageCache.getByFileName(filename) ||
    oldLanguageCache.getByExtension(getExtension(filename)) ||
    null
  );
};
